import { render, staticRenderFns } from "./DocumentUboView.vue?vue&type=template&id=22dd8395&scoped=true&"
import script from "./DocumentUboView.vue?vue&type=script&lang=js&"
export * from "./DocumentUboView.vue?vue&type=script&lang=js&"
import style0 from "./DocumentUboView.vue?vue&type=style&index=0&id=22dd8395&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22dd8395",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22dd8395')) {
      api.createRecord('22dd8395', component.options)
    } else {
      api.reload('22dd8395', component.options)
    }
    module.hot.accept("./DocumentUboView.vue?vue&type=template&id=22dd8395&scoped=true&", function () {
      api.rerender('22dd8395', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/DocumentUboView.vue"
export default component.exports